import {
  getCreatedByDisplay,
  getQuestionnaireLanguageNames,
  type FormManagementQuestionnaireListItem,
} from './questionnaireListDisplay';
import { FormData, FormStatusTab, FormType } from './types';

const CATEGORY_KEY_TO_FORM_TYPE: Record<string, FormType> = {
  speak_up: FormType.SPEAK_UP,
  disclosure: FormType.CONFLICT_OF_INTEREST,
};

function toFormStatusTab(status: string | null | undefined): FormStatusTab {
  switch (status?.toLowerCase()) {
    case 'active':
      return FormStatusTab.ACTIVE;
    case 'draft':
      return FormStatusTab.DRAFTS;
    case 'archived':
      return FormStatusTab.ARCHIVED;
    case 'inactive':
    case 'unpublished':
      return FormStatusTab.UNPUBLISHED;
    default:
      return FormStatusTab.DRAFTS;
  }
}

function toFormType(categoryKey: string | null | undefined): FormType {
  if (categoryKey == null || typeof categoryKey !== 'string') {
    return FormType.CONFLICT_OF_INTEREST;
  }
  const key = categoryKey.toLowerCase();
  return CATEGORY_KEY_TO_FORM_TYPE[key] ?? FormType.CONFLICT_OF_INTEREST;
}

export function mapQuestionnaireToFormData(
  item: FormManagementQuestionnaireListItem,
): FormData {
  const category = item.category ?? '';
  const countries = item.countries ?? [];
  const countryNames = countries
    .map((c) => c.countryName)
    .filter((name): name is string => name != null && name !== '');

  return {
    id: item.id ?? '',
    title: item.publicTitle ?? item.internalName ?? '',
    category,
    categoryId: item.categoryId ?? undefined,
    country: countryNames.join(', '),
    description: item.description ?? '',
    languages: getQuestionnaireLanguageNames(item).join(', '),
    questionsCount: item.stats?.totalQuestions ?? 0,
    createdBy: getCreatedByDisplay(item.createdBy),
    createdAt: item.createdAt ?? '',
    lastUpdated: item.updatedAt ?? '',
    status: toFormStatusTab(item.status),
    type: toFormType(item.formCategory?.categoryKey),
    countryCount: countries.length,
  };
}

export function mapQuestionnairesToFormData(
  items: FormManagementQuestionnaireListItem[],
): FormData[] {
  return items.map(mapQuestionnaireToFormData);
}
